import IReportService from "@/services/IReportService";
import ReportCreate from "@/models/report/ReportCreate";
import CreateResponse from "@/models/CreateResponse";
import Report from "@/models/report/Report";
import ReportListFilter from "@/models/report/ReportListFilter";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import ReportListEntry from "@/models/report/ReportListEntry";
import PaginatedResponse from "@/models/PaginatedResponse";
import ReportUpdate from "@/models/report/ReportUpdate";
import Vue from "vue";
import {ReportState} from "@/helpers/constants";
import ReportLinesUpdate from "@/models/reportLine/ReportLinesUpdate";

export default class AxiosReportService implements IReportService {

	public report(id: string): Promise<Report> {
		return Vue.$axios.get<Report>(`/report/${id}`).then(res => res.data);
	}

	public reports(filter: ReportListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<ReportListEntry>> {
		return Vue.$axios.get<PaginatedResponse<ReportListEntry>>('/report', {
			params: {
				...filter,
				...options
			}
		}).then(res => res.data);
	}

	public create(model: ReportCreate): Promise<CreateResponse> {
		return Vue.$axios.post<CreateResponse>('/report', model).then(res => res.data);
	}

	public update(id: string, model: ReportUpdate): Promise<null> {
		return Vue.$axios.patch(`/report/${id}`, model).then(res => res.data);
	}

	public updateNotesAdministration(id: string, notesAdministration: string | null): Promise<null> {
		return Vue.$axios.put(`/report/${id}/notes-administration`, {
			notesAdministration: notesAdministration,
		}).then(res => res.data);
	}

	public delete(id: string): Promise<null> {
		return Vue.$axios.delete(`/report/${id}`).then(res => res.data);
	}

	public state(id: string, requestedState: ReportState): Promise<null> {
		return Vue.$axios.put(`/report/${id}/state`, {
			state: requestedState,
		}).then(res => res.data);
	}

	public updateReportLines(id: string, model: ReportLinesUpdate): Promise<null> {
		return Vue.$axios.put(`/report/${id}/report-line`, model).then(res => res.data);
	}

}
